import PropTypes from 'prop-types';

var WidgetGridActions = require('../../constants').WidgetGridActions;

var WidgetWrapper = {

  WIDGET_REF: "Widget",

  contextTypes: {
    registerWidget: PropTypes.func,
    unregisterWidget: PropTypes.func
  },

  propTypes: {
    widgetData: PropTypes.object.isRequired,
    onWidgetDelete: PropTypes.func
  },

  componentDidMount(){
    this.context.registerWidget(
      this.props.widgetData.id,
      ReactDOM.findDOMNode(this.refs['Widget']),
      this.widgetActionCallback);
  },

  widgetActionCallback(actionType){
    switch (actionType) {
      case WidgetGridActions.ACTION_DELETE:
        if (this.props.onWidgetDelete) {
          this.props.onWidgetDelete(this.props.widgetData.id);
        }
        break;
    }
  }

};

module.exports = WidgetWrapper;
